import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import Link from '../Link';
import s from './BackToHomeArrow.css';

function BackToHomeArrow({ className = null }) {
  return (
    <Link
      to="/"
      className={cx(s.backArrow, className)}
      aria-label="Volver a inicio"
      title="Volver a inicio"
    >
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        focusable="false"
      >
        <line x1="19" y1="12" x2="5" y2="12" />
        <polyline points="12 19 5 12 12 5" />
      </svg>
    </Link>
  );
}

BackToHomeArrow.propTypes = {
  className: PropTypes.string,
};

export default withStyles(s)(BackToHomeArrow);
